import { a as r } from "./caml-aa4fccd9.mjs";

import { s as n, v as a } from "./caml_option-16487d6d.mjs";

function floor_int(r) {
  if (r > 2147483647) {
    return 2147483647;
  } else if (r < -2147483648) {
    return -2147483648;
  } else {
    return Math.floor(r);
  }
}

function random_int(r, n) {
  return floor_int(Math.random() * (n - r | 0)) + r | 0;
}

function get(r, a) {
  if (a >= 0 && a < r.length) {
    return n(r[a]);
  }
}

function getExn(r, n) {
  if (!(n >= 0 && n < r.length)) {
    throw {
      RE_EXN_ID: "Assert_failure",
      _1: [ "belt_Array.ml", 35, 2 ],
      Error: new Error
    };
  }
  return r[n];
}

function swapUnsafe(r, n, a) {
  var e = r[n];
  r[n] = r[a];
  r[a] = e;
}

function shuffle(r) {
  var n = r.slice(0);
  !function shuffleInPlace(r) {
    var n = r.length;
    for (var a = 0; a < n; ++a) {
      swapUnsafe(r, a, random_int(a, n));
    }
  }(n);
  return n;
}

function reverse(r) {
  var n = r.length;
  var a = new Array(n);
  for (var e = 0; e < n; ++e) {
    a[e] = r[(n - 1 | 0) - e | 0];
  }
  return a;
}

function make(r, n) {
  if (r <= 0) {
    return [];
  }
  var a = new Array(r);
  for (var e = 0; e < r; ++e) {
    a[e] = n;
  }
  return a;
}

function makeByU(r, n) {
  if (r <= 0) {
    return [];
  }
  var a = new Array(r);
  for (var e = 0; e < r; ++e) {
    a[e] = n(e);
  }
  return a;
}

function range(r, n) {
  var a = n - r | 0;
  if (a < 0) {
    return [];
  }
  var e = new Array(a + 1 | 0);
  for (var t = 0; t <= a; ++t) {
    e[t] = r + t | 0;
  }
  return e;
}

function rangeBy(r, n, a) {
  var e = n - r | 0;
  if (e < 0 || a <= 0) {
    return [];
  }
  var t = 1 + (e / a | 0) | 0;
  var v = new Array(t);
  var f = r;
  for (var o = 0; o < t; ++o) {
    v[o] = f;
    f = f + a | 0;
  }
  return v;
}

function zip(r, n) {
  var a = r.length;
  var e = n.length;
  var t = a < e ? a : e;
  var v = new Array(t);
  for (var f = 0; f < t; ++f) {
    v[f] = [ r[f], n[f] ];
  }
  return v;
}

function zipByU(r, n, a) {
  var e = r.length;
  var t = n.length;
  var v = e < t ? e : t;
  var f = new Array(v);
  for (var o = 0; o < v; ++o) {
    f[o] = a(r[o], n[o]);
  }
  return f;
}

function concat(r, n) {
  var a = r.length;
  var e = n.length;
  var t = new Array(a + e | 0);
  for (var v = 0; v < a; ++v) {
    t[v] = r[v];
  }
  for (var f = 0; f < e; ++f) {
    t[a + f | 0] = n[f];
  }
  return t;
}

function concatMany(r) {
  var n = r.length;
  var a = 0;
  for (var e = 0; e < n; ++e) {
    a = a + r[e].length | 0;
  }
  var t = new Array(a);
  a = 0;
  for (var v = 0; v < n; ++v) {
    var f = r[v];
    for (var o = 0, i = f.length; o < i; ++o) {
      t[a] = f[o];
      a = a + 1 | 0;
    }
  }
  return t;
}

function slice(n, a, e) {
  if (e <= 0) {
    return [];
  }
  var t = n.length;
  var v = a < 0 ? r(t + a | 0, 0) : a;
  var f = t - v | 0;
  var o = f < e ? f : e;
  if (o <= 0) {
    return [];
  }
  var i = new Array(o);
  for (var u = 0; u < o; ++u) {
    i[u] = n[v + u | 0];
  }
  return i;
}

function sliceToEnd(n, a) {
  var e = n.length;
  var t = a < 0 ? r(e + a | 0, 0) : a;
  var v = e > t ? e - t | 0 : 0;
  var f = new Array(v);
  for (var o = 0; o < v; ++o) {
    f[o] = n[t + o | 0];
  }
  return f;
}

function blitUnsafe(r, n, a, e, t) {
  if (e <= n) {
    for (var v = 0; v < t; ++v) {
      a[v + e | 0] = r[v + n | 0];
    }
    return;
  }
  for (var f = t - 1 | 0; f >= 0; --f) {
    a[f + e | 0] = r[f + n | 0];
  }
}

function forEachU(r, n) {
  for (var a = 0, e = r.length; a < e; ++a) {
    n(r[a]);
  }
}

function mapU(r, n) {
  var a = r.length;
  var e = new Array(a);
  for (var t = 0; t < a; ++t) {
    e[t] = n(r[t]);
  }
  return e;
}

function getByU(r, a) {
  var e = r.length;
  var t = 0;
  var v;
  while (void 0 === v && t < e) {
    var f = r[t];
    if (a(f)) {
      v = n(f);
    }
    t = t + 1 | 0;
  }
  return v;
}

function getIndexByU(r, n) {
  var a = r.length;
  var e = 0;
  var t;
  while (void 0 === t && e < a) {
    if (n(r[e])) {
      t = e;
    }
    e = e + 1 | 0;
  }
  return t;
}

function keepMapU(r, n) {
  var e = r.length;
  var t = new Array(e);
  var v = 0;
  for (var f = 0; f < e; ++f) {
    var o = n(r[f]);
    if (void 0 !== o) {
      t[v] = a(o);
      v = v + 1 | 0;
    }
  }
  t.length = v;
  return t;
}

function forEachWithIndexU(r, n) {
  for (var a = 0, e = r.length; a < e; ++a) {
    n(a, r[a]);
  }
}

function mapWithIndexU(r, n) {
  var a = r.length;
  var e = new Array(a);
  for (var t = 0; t < a; ++t) {
    e[t] = n(t, r[t]);
  }
  return e;
}

function reduceU(r, n, a) {
  var e = n;
  for (var t = 0, v = r.length; t < v; ++t) {
    e = a(e, r[t]);
  }
  return e;
}

function reduceReverseU(r, n, a) {
  var e = n;
  for (var t = r.length - 1 | 0; t >= 0; --t) {
    e = a(e, r[t]);
  }
  return e;
}

function reduceWithIndexU(r, n, a) {
  var e = n;
  for (var t = 0, v = r.length; t < v; ++t) {
    e = a(e, r[t], t);
  }
  return e;
}

function everyU(r, n) {
  var a = r.length;
  var e = 0;
  while (1) {
    var t = e;
    if (t === a) {
      return !0;
    }
    if (!n(r[t])) {
      return !1;
    }
    e = t + 1 | 0;
  }
}

function someU(r, n) {
  var a = r.length;
  var e = 0;
  while (1) {
    var t = e;
    if (t === a) {
      return !1;
    }
    if (n(r[t])) {
      return !0;
    }
    e = t + 1 | 0;
  }
}

function eqU(r, n, a) {
  var e = r.length;
  if (e === n.length) {
    return function everyAux2(r, n, a, e, t) {
      while (1) {
        var v = a;
        if (v === t) {
          return !0;
        }
        if (!e(r[v], n[v])) {
          return !1;
        }
        a = v + 1 | 0;
      }
    }(r, n, 0, a, e);
  } else {
    return !1;
  }
}

function partitionU(r, n) {
  var a = r.length;
  var e = 0;
  var t = 0;
  var v = new Array(a);
  var f = new Array(a);
  for (var o = 0; o < a; ++o) {
    var i = r[o];
    if (n(i)) {
      v[e] = i;
      e = e + 1 | 0;
    } else {
      f[t] = i;
      t = t + 1 | 0;
    }
  }
  v.length = e;
  f.length = t;
  return [ v, f ];
}

function unzip(r) {
  var n = r.length;
  var a = new Array(n);
  var e = new Array(n);
  for (var t = 0; t < n; ++t) {
    var v = r[t];
    a[t] = v[0];
    e[t] = v[1];
  }
  return [ a, e ];
}

export { zip as A, zipByU as B, forEachWithIndexU as C, getIndexByU as D, keepMapU as E, reduceWithIndexU as a, mapU as b, concat as c, blitUnsafe as d, everyU as e, forEachU as f, reverse as g, get as h, sliceToEnd as i, slice as j, getExn as k, shuffle as l, makeByU as m, concatMany as n, random_int as o, make as p, getByU as q, reduceU as r, someU as s, mapWithIndexU as t, unzip as u, reduceReverseU as v, partitionU as w, eqU as x, range as y, rangeBy as z };
